import React, { useContext } from "react"
import { Link } from "react-router-dom"
import AppContext from "../../../../shared/AppContext"

const ViewReportButton = (props) => {
  const { product, from } = props
  const { trackEvent } = useContext(AppContext)

  if (!product || !product.slug || !product.available) {
    return null
  }

  const slug = product.slug[0]

  const productPath =
    product.isPurchased || product.isSpecialAccess ? "/view" : ""

  return (
    <Link
      className="model-nav-btn model-view-report-btn"
      to={`/marketplace/${slug + productPath}`}
      onClick={() => {
        trackEvent("View Report", {
          linkTo: `/marketplace/${slug + productPath}`,
          from: from,
        })
      }}
      data-cy="view-report-btn"
    >
      <div>View Report</div>
    </Link>
  )
}

export default ViewReportButton
